/**
 * Page Aide — guide d'utilisation de Census by Doodive.
 */

import { el, clear } from '../js/utils.js';
import { t } from '../js/i18n.js';
import { renderHeader } from '../components/header.js';
import { renderFooter } from '../components/footer.js';

export async function renderHelp(root) {
  clear(root);

  const view = el(
    'main',
    { class: 'help-page container' },
    el('p', { class: 'eyebrow', style: { marginTop: 'var(--space-5)', color: 'var(--coral)' } }, t('help.eyebrow')),
    el('h1', { class: 'help-title' }, t('help.title')),
    el('hr', { class: 'divider' }),
    buildSection('help.s1.title', 'help.s1.body'),
    buildSection('help.s2.title', 'help.s2.body'),
    buildSection('help.s3.title', 'help.s3.body')
  );

  root.append(renderHeader(), view, renderFooter());
}

function buildSection(titleKey, bodyKey) {
  return el(
    'section',
    { class: 'help-section' },
    el('h2', { class: 'help-section-title' }, t(titleKey)),
    el('p', { class: 'help-section-body muted' }, t(bodyKey))
  );
}
